import {
  fontFamily,
  fontStyle,
  labelPosition,
  legendPosition,
  tooltipTrigger,
  tooltipTriggerOn,
  borderStyle,
} from "./options";
export const dataAttr = [
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "数据类型",
    field: "dataConfig.type",
    fieldType: "data",
    type: "Select",
    options: [
      {
        id: 1,
        name: "页面静态数据",
      },
      {
        id: 2,
        name: "指标接入",
      },
    ],
    value: 2,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "静态数据",
    field: "dataConfig.staticData",
    fieldType: "data",
    type: "Table",
    value: [
      ["系列", "2015", "2016", "2017"],
      ["名称2", 43.3, 85.8, 93.7],
      ["名称3", 83.1, 73.4, 55.1],
      ["名称4", 86.4, 65.2, 82.5],
      ["名称5", 72.4, 53.9, 39.1],
    ],
    onFilter: `props['dataConfig.type'] === 1`,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "指标名称",
    field: "dataConfig.quota.id",
    fieldType: "data",
    type: "Select",
    onFilter: `props['dataConfig.type'] === 2`,
    options: [],
    opts: {
      mode: "multiple",
    },
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "选择级别",
    field: "dataConfig.quota.level",
    fieldType: "data",
    type: "Select",
    onFilter: `props['dataConfig.type'] === 2`,
    options: [],
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "配置维度",
    field: "dataConfig.quota.dimension",
    fieldType: "data",
    type: "CheckboxGroup",
    onFilter: `props['dataConfig.type'] === 2`,
    options: [],
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "更新周期",
    field: "dataConfig.quota.updateDuration",
    fieldType: "data",
    type: "InputNumber",
    onFilter: `props['dataConfig.type'] === 2`,
    value: 5,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "排序类型",
    field: "dataConfig.quota.sortType",
    fieldType: "data",
    type: "Select",
    options: [
      { id: 1, name: "按指标值排序" },
      { id: 2, name: "按时间排序" },
    ],
    onFilter: `props['dataConfig.type'] === 2`,
    value: 1,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "排序方向",
    field: "dataConfig.quota.sortValueDic",
    fieldType: "data",
    type: "Select",
    options: [
      { id: 1, name: "指标值升序" },
      { id: 2, name: "指标值降序" },
      { id: 3, name: "默认排序" },
    ],
    onFilter: `props['dataConfig.type'] === 2 && props['dataConfig.quota.sortType'] === 1`,
    value: 3,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "排序方向",
    field: "dataConfig.quota.sortTimeDic",
    fieldType: "data",
    type: "Select",
    options: [
      { id: 1, name: "时间升序" },
      { id: 2, name: "时间降序" },
      { id: 3, name: "默认排序" },
    ],
    onFilter: `props['dataConfig.type'] === 2 && props['dataConfig.quota.sortType'] === 2`,
    value: 3,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "显示数量",
    field: "dataConfig.quota.totalCount",
    fieldType: "data",
    type: "InputNumber",
    onFilter: `props['dataConfig.type'] === 2`,
    value: 10,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "每页数量",
    field: "dataConfig.quota.pageSize",
    fieldType: "data",
    type: "InputNumber",
    onFilter: `props['dataConfig.type'] === 2`,
    value: 10,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "翻转数据",
    field: "dataConfig.quota.flip",
    fieldType: "data",
    type: "Switch",
    value: false,
  },
  {
    archive: "数据配置",
    domain: "数据配置",
    name: "复合指标",
    field: "dataConfig.quota.useCombine",
    fieldType: "data",
    type: "Switch",
    value: false,
  },
];
export const attr = [
  {
    archive: "位置尺寸",
    domain: "位置",
    name: "X",
    field: "left",
    type: "InputNumber",
  },
  {
    archive: "位置尺寸",
    domain: "位置",
    name: "Y",
    field: "top",
    type: "InputNumber",
  },
  {
    archive: "位置尺寸",
    domain: "尺寸",
    name: "W宽度",
    field: "width",
    type: "InputNumber",
    value: 250,
  },
  {
    archive: "位置尺寸",
    domain: "尺寸",
    name: "H高度",
    field: "height",
    type: "InputNumber",
    value: 250,
  },
  {
    archive: "配色方案",
    domain: "配色方案",
    name: "配色方案",
    field: "color",
    fieldType: "props",
    type: "Color2",
    value: [
      "#696CFF",
      // "#4645E6",
      "#0AD239",
      "#08A62D",
      "#03CAF4",
      "#FF2525",
      "#FF6A00",
      "#FFD609",
      "#C667FB",
    ],
  },
  {
    archive: "图表标题",
    domain: "标题",
    name: "标题显示",
    field: "title.show",
    type: "Switch",
    value: true,
  },
  {
    archive: "图表标题",
    domain: "标题",
    name: "标题内容",
    field: "title.text",
    type: "Input",
  },
  {
    archive: "图表标题",
    domain: "标题",
    name: "字体选择",
    field: "title.textStyle.fontFamily",
    type: "Select",
    options: fontFamily,
  },
  {
    archive: "图表标题",
    domain: "标题",
    name: "字体大小",
    field: "title.textStyle.fontSize",
    type: "InputNumber",
    value: 14,
  },
  {
    archive: "图表标题",
    domain: "标题",
    name: "字体颜色",
    field: "title.textStyle.color",
    type: "Color",
    value: "rgba(255,255,255,0.8)",
  },
  {
    archive: "图表标题",
    domain: "标题",
    name: "字体样式",
    field: "title.textStyle.fontStyle,title.textStyle.fontWeight",
    type: "Select",
    options: fontStyle,
  },

  {
    archive: "图表数据",
    domain: "数据标签",
    name: "标签显示",
    field: "series[].label.show",
    type: "Switch",
    value: false,
  },
  {
    archive: "图表数据",
    domain: "数据标签",
    name: "字体选择",
    field: "series[].label.fontFamily",
    type: "Select",
    options: fontFamily,
  },
  {
    archive: "图表数据",
    domain: "数据标签",
    name: "字体颜色",
    field: "series[].label.color",
    type: "Color",
    value: "rgba(255,255,255,0.8)",
  },
  {
    archive: "图表数据",
    domain: "数据标签",
    name: "字体大小",
    field: "series[].label.fontSize",
    type: "InputNumber",
    value: 12,
  },
  {
    archive: "图表数据",
    domain: "数据标签",
    name: "字体样式",
    field: "series[].label.fontStyle,series[].label.fontWeight",
    type: "Select",
    options: fontStyle,
  },
  {
    archive: "图表数据",
    domain: "数据标签",
    name: "标签位置",
    field: "series[].label.position",
    type: "Select",
    options: labelPosition,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "标签显示",
    field: "xAxis.axisLabel.show",
    type: "Switch",
    value: true,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "标签颜色",
    field: "xAxis.axisLabel.color",
    type: "Color",
    value: "#FFF",
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "字体大小",
    field: "xAxis.axisLabel.fontSize",
    type: "InputNumber",
    value: 12,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "字体样式",
    field: "xAxis.axisLabel.fontStyle,xAxis.axisLabel.fontWeight",
    type: "Select",
    options: fontStyle,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "标签角度",
    field: "xAxis.axisLabel.rotate",
    type: "InputNumber",
    value: 0,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "轴线显示",
    field: "xAxis.axisLine.show",
    type: "Switch",
    value: false,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "轴线颜色",
    field: "xAxis.axisLine.lineStyle.color",
    type: "Color",
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "刻度显示",
    field: "xAxis.axisTick.show",
    type: "Switch",
    value: false,
  },
  {
    archive: "坐标轴",
    domain: "X轴",
    name: "刻度颜色",
    field: "xAxis.axisTick.lineStyle.color",
    type: "Color",
  },
  /** Y轴 */
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "标签显示",
    field: "yAxis.axisLabel.show",
    type: "Switch",
  },
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "标签颜色",
    field: "yAxis.axisLabel.color",
    type: "Color",
    value: "#FFF",
  },
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "字体大小",
    field: "yAxis.axisLabel.fontSize",
    type: "InputNumber",
  },
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "字体样式",
    field: "yAxis.axisLabel.fontStyle,yAxis.axisLabel.fontWeight",
    type: "Select",
    options: fontStyle,
  },
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "标签角度",
    field: "yAxis.axisLabel.rotate",
    type: "InputNumber",
    value: 0,
  },
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "轴线显示",
    field: "yAxis.axisLine.show",
    type: "Switch",
    value: false,
  },
  {
    archive: "坐标轴",
    domain: "Y轴",
    name: "轴线颜色",
    field: "yAxis.axisLine.lineStyle.color",
    type: "Color",
  },
  {
    archive: "网格",
    domain: "网格",
    name: "上边距",
    field: "grid.top",
    type: "InputNumber",
  },
  {
    archive: "网格",
    domain: "网格",
    name: "下边距",
    field: "grid.bottom",
    type: "InputNumber",
  },
  {
    archive: "网格",
    domain: "网格",
    name: "左边距",
    field: "grid.left",
    type: "InputNumber",
  },
  {
    archive: "网格",
    domain: "网格",
    name: "右边距",
    field: "grid.right",
    type: "InputNumber",
  },
  {
    archive: "图例",
    domain: "图例",
    name: "图例显示",
    field: "legend.show",
    type: "Switch",
    value: false,
  },
  {
    archive: "图例",
    domain: "图例",
    name: "字体颜色",
    field: "legend.textStyle.color",
    type: "Color",
    value: "rgba(255,255,255,0.8)",
  },
  {
    archive: "图例",
    domain: "图例",
    name: "字体大小",
    field: "legend.textStyle.fontSize",
    type: "InputNumber",
    value: 12,
  },
  {
    archive: "图例",
    domain: "图例",
    name: "字体样式",
    field: "legend.textStyle.fontStyle,legend.textStyle.fontWeight",
    type: "Select",
    options: fontStyle,
  },
  {
    archive: "图例",
    domain: "图例",
    name: "图例位置",
    field: "legend.top,legend.right,legend.bottom,legend.left",
    type: "Select",
    options: legendPosition,
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "提示显示",
    field: "tooltip.show",
    type: "Switch",
    value: true,
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "触发类型",
    field: "tooltip.trigger",
    type: "Select",
    options: tooltipTrigger,
    value: "axis",
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "触发条件",
    field: "tooltip.triggerOn",
    type: "Select",
    options: tooltipTriggerOn,
    value: "mousemove",
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "字体颜色",
    field: "tooltip.textStyle.color",
    type: "Color",
    value: "#FFF",
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "字体大小",
    field: "tooltip.textStyle.fontSize",
    type: "InputNumber",
    value: 12,
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "字体选择",
    field: "tooltip.textStyle.fontFamily",
    type: "Select",
    options: fontFamily,
  },
  {
    archive: "提示信息",
    domain: "提示信息",
    name: "字体样式",
    field: "tooltip.textStyle.fontStyle,tooltip.textStyle.fontWeight",
    type: "Select",
    options: fontStyle,
  },
  {
    archive: "背景",
    domain: "背景",
    name: "背景颜色",
    field: "backgroundColor",
    type: "Color",
    fieldType: "props",
    value: "rgba(0,0,0,0)",
    onChange: `props.backgroundOpacity=value.match(/\\,([^\\,]*?)\\)/)[1] * 100`,
  },
  {
    archive: "背景",
    domain: "背景",
    name: "不透明度",
    field: "backgroundOpacity",
    type: "Slider",
    fieldType: "props",
    onParse: "preProps.backgroundColor.match(/\\,([^\\,]*?)\\)/)[1] * 100",
    onChange: `props.backgroundColor=props.backgroundColor.replace(/\\,([^\,]*?)\\)/, ',' + value / 100 + ')')`,
  },
  // {
  //     "archive": "背景",
  //     "domain": "背景",
  //     "name": "阴影颜色",
  //     "field": "",
  //     "type": "Color"
  // },
  // {
  //     "archive": "背景",
  //     "domain": "背景",
  //     "name": "阴影设置",
  //     "field": "",
  //     "type": "InputNumber"
  // },
  {
    archive: "背景",
    domain: "边框",
    name: "边框圆角",
    field: "borderRadius",
    fieldType: "style",
    type: "InputNumber",
  },
  {
    archive: "背景",
    domain: "边框",
    name: "描边颜色",
    field: "borderColor",
    fieldType: "style",
    type: "Color",
    value: "rgba(0,0,0,0)",
    onChange: `style.borderOpacity=value.match(/\\,([^\\,]*?)\\)/)[1] * 100`,
  },
  {
    archive: "背景",
    domain: "边框",
    name: "描边样式",
    field: "borderStyle",
    fieldType: "style",
    type: "Select",
    options: borderStyle,
    value: "solid",
  },
  {
    archive: "背景",
    domain: "边框",
    name: "描边粗细",
    field: "borderWidth",
    fieldType: "style",
    type: "InputNumber",
  },
  {
    archive: "背景",
    domain: "边框",
    name: "不透明度",
    field: "borderOpacity",
    fieldType: "style",
    type: "Slilder",
    onParse: "preStyle.borderColor.match(/\\,([^\\,]*?)\\)/)[1] * 100",
    onChange: `style.borderColor=style.borderColor.replace(/\\,([^\,]*?)\\)/, ',' + value / 100 + ')')`,
  },
  {
    archive: "动画",
    domain: "开启动画",
    name: "开启动画",
    field: "animation",
    fieldType: "props",
    type: "Switch",
    value: true,
  },
  {
    archive: "动画",
    domain: "开启动画",
    name: "初始动画时长",
    field: "animationDuration",
    fieldType: "props",
    type: "InputNumber",
    value: 1000,
  },
  {
    archive: "动画",
    domain: "开启动画",
    name: "初始动画延迟",
    field: "animationDelay",
    fieldType: "props",
    type: "InputNumber",
    value: 0,
  },
  {
    archive: "动画",
    domain: "开启动画",
    name: "数据更新时长",
    field: "animationDurationUpdate",
    fieldType: "props",
    type: "InputNumber",
    value: 300,
  },
  {
    archive: "动画",
    domain: "开启动画",
    name: "数据更新延迟",
    field: "animationDelayUpdate",
    fieldType: "props",
    type: "InputNumber",
    value: 0,
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "数据宽度",
    field: "series[].barWidth",
    type: "Slilder",
    value: 15,
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "数据间距",
    field: "series[].barGap",
    type: "Slilder",
    value: 0,
  },
  // {
  //     "archive": "图表设置",
  //     "domain": "系列",
  //     "name": "发光不透明度",
  //     "field": "",
  //     "type": "Slilder"
  // },
  // {
  //     "archive": "图表设置",
  //     "domain": "发光",
  //     "name": "范围",
  //     "field": "",
  //     "type": "Slilder"
  // },
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边颜色",
    field: "series[].itemStyle.borderColor",
    type: "Color",
    value: "#FFF",
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边宽度",
    field: "series[].itemStyle.borderWidth",
    type: "Slider",
    value: 0,
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边线型",
    field: "series[].itemStyle.borderType",
    type: "Select",
    options: borderStyle,
    value: "solid",
  },
  //TODO borderRadius不生效
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边左上角",
    field: "series[].itemStyle.borderRadiusLeftTop",
    type: "Slilder",
    value: 0,
    onParse: "preProps['series[].itemStyle.borderRadius'][0]",
    onChange: `props['series[].itemStyle.borderRadius'] = props['series[].itemStyle.borderRadius'] || [0,0,0,0];props['series[].itemStyle.borderRadius'][0]=+value;`,
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边右上角",
    field: "series[].itemStyle.borderRadiusRightTop",
    type: "Slilder",
    value: 0,
    onParse: "preProps['series[].itemStyle.borderRadius'][1]",
    onChange: `props['series[].itemStyle.borderRadius'] = props['series[].itemStyle.borderRadius'] || [0,0,0,0];props['series[].itemStyle.borderRadius'][1]=+value;`,
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边右下角",
    field: "series[].itemStyle.borderRadiusRightBottom",
    type: "Slilder",
    value: 0,
    onParse: "preProps['series[].itemStyle.borderRadius'][2]",
    onChange: `props['series[].itemStyle.borderRadius'] = props['series[].itemStyle.borderRadius'] || [0,0,0,0];props['series[].itemStyle.borderRadius'][2]=+value;`,
  },
  {
    archive: "图表设置",
    domain: "系列",
    name: "描边左下角",
    field: "series[].itemStyle.borderRadiusLeftBottom",
    type: "Slilder",
    value: 0,
    onParse: "preProps['series[].itemStyle.borderRadius'][3]",
    onChange: `props['series[].itemStyle.borderRadius'] = props['series[].itemStyle.borderRadius'] || [0,0,0,0];props['series[].itemStyle.borderRadius'][3]=+value;`,
  },

  // {
  //     "archive": "",
  //     "domain": "端点",
  //     "name": "断点图片",
  //     "field": "",
  //     "type": "Upload"
  // },
  // {
  //     "archive": "",
  //     "domain": "",
  //     "name": "形状",
  //     "field": "",
  //     "type": "Select"
  // },
  // {
  //     "archive": "",
  //     "domain": "",
  //     "name": "显示",
  //     "field": "",
  //     "type": "Switch"
  // },
  // {
  //     "archive": "",
  //     "domain": "",
  //     "name": "宽",
  //     "field": "",
  //     "type": "Slilder"
  // },
  // {
  //     "archive": "",
  //     "domain": "",
  //     "name": "高",
  //     "field": "",
  //     "type": "Slilder"
  // },
  // {
  //     "archive": "",
  //     "domain": "",
  //     "name": "范围",
  //     "field": "",
  //     "type": "Select"
  // },
  // {
  //     "archive": "",
  //     "domain": "槽位",
  //     "name": "宽度",
  //     "field": "",
  //     "type": "Slilder"
  // }
  ...dataAttr,
];

export const getAttr = (
  domainList = [],
  props = {},
  filetrDomain = [],
  filterNames = []
) => {
  let res = attr.filter(
    (a) =>
      (!domainList || !domainList.length
        ? true
        : domainList.includes(a.domain)) &&
      !filetrDomain.includes(a.domain) &&
      !filterNames.includes(a.name)
  );

  return res.map((a) => {
    let r = {
      ...a,
    };
    if (r.field in props) {
      r.value = props[r.field];
    }
    return r;
  });
};
